import request from '../../../../api/request';
import { SelectOptionType } from '@octano/global-ui';
import type {
  ReportFormData,
  ReportAuditOfGradesFormData,
  ReportTeachersOccupationFormData,
} from './type';

export const REPORT = {
  FORM_DATA: '/report/form',
  FORM_RESOURCES: '/report/resources',
  FORM_AUDIT_OF_GRADES_DATA: '/report/audit-of-grades/form',
  FORM_TEACHERS_OCCUPATION_DATA: '/report/teachers-occupation/form',
  FORM_SPACES_OCCUPATION_DATA: '/report/spaces-occupation/form',
};

export function getFormData() {
  return request<ReportFormData>(REPORT.FORM_DATA, {
    method: 'get',
  });
}
export function getResourcesData(resources: string[]) {
  return request<Record<string, SelectOptionType[]>>(REPORT.FORM_RESOURCES, {
    method: 'post',
    data: { resources },
  });
}

export function getAuditOfGradesFormData() {
  return request<ReportAuditOfGradesFormData>(REPORT.FORM_AUDIT_OF_GRADES_DATA);
}

export function getTeachersOccupationFormData() {
  return request<ReportTeachersOccupationFormData>(
    REPORT.FORM_TEACHERS_OCCUPATION_DATA,
  );
}

export function getSpacesOccupationFormData() {
  return request<any>(REPORT.FORM_SPACES_OCCUPATION_DATA);
}
